import { TypedError } from './TypedError'

/**
 * 致命错误，中断后续执行
 */
export abstract class FatalError extends TypedError {}
